import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { WeezHeader, Button, EmptyCard } from '@weezevent/nacre';
import ImageEmptyCard from '../../../images/image_empty_error.png';
import { getMenhirUrl } from '../../../utils/config';

export default function PrintStockRedirect({ event }) {
    const menhirUrl = getMenhirUrl();

    return (
        <div>
            <WeezHeader title={<Trans i18nKey="attendees.printStock.title" />} />
            <EmptyCard
                title={<Trans i18nKey="empty.title" />}
                subTitle={<Trans i18nKey="empty.subtitle" />}
                image={ImageEmptyCard}
                cta={menhirUrl ? <Button primary label={<Trans i18nKey="empty.cta" />} as="a" href={`${menhirUrl}/canaux_impression.php?id_evenement=${event.id}`} /> : null}
            />
        </div>
    );
}

PrintStockRedirect.propTypes = {
    event: PropTypes.object.isRequired
};
